import React, { Fragment, useState, useEffect, useContext } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import EmailIcon from '@material-ui/icons/Email';
import ThumbsUpDownIcon from '@material-ui/icons/ThumbsUpDown';
import LiveHelp from '@material-ui/icons/LiveHelp';
import HomeWork from '@material-ui/icons/HomeWork';
import ScheduleIcon from '@material-ui/icons/Schedule';
import { Row, Container, CardBody, Col, Card } from 'reactstrap';
import format from 'date-fns/format';
import ReactRouterPropTypes from 'react-router-prop-types';
import PropTypes from 'prop-types';
import { v4 as uuid } from 'uuid';
import { showNotificationAutoDestroy } from '../../shared/components/ShowNotification';
import Modal from '../../shared/components/Modal';
import GraphQl from '../../GraphQL';
import {
  communicationRemoveQuery,
  communicationFindByTypeFilterQuery,
  getCommunicationResultsViewedWrapper,
} from '../../shared/queries/Communication';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../redux/actions/loadingActions';
import MaterialTable from '../../shared/components/material-table';
import MemoBox from '../Memo/components/MemoBox';
import MemoTypeModal from '../Memo/components/MemoTypeModal';
import columns from './components/Columns';
import {
  ACTION_NAME,
  COMMUNICATION_TYPE,
  EMPTY_STRING,
  PERIOD_TYPE,
  REPORT_PARAMETERS,
  REPORT_TYPES,
} from '../../shared/utils/constants';
import FullScreenDialog from '../../shared/components/FullScreenDialog';
import VisualizationMetricsView from './components/visualizationMetrics/VisualizationMetricsView';
import SurveyMetricsView from './components/surveyMetrics/SurveyMetricsView';
import CommunicationFilter from './components/Filter';
import { employeeListByFilter } from '../../shared/queries/Appointment';
import { classListActivesByFunc } from '../../shared/queries/SchoolClass';
import { studentListByFilter } from '../../shared/queries/Student';
import {
  generateReport,
  openReport,
  updatePendency,
} from '../../shared/utils/smartutils';
import SmartContext from '../App/context/SmartContext';
import ActivityOrEvaluationCorrection from './components/correction/ActivityOrEvaluationCorrection';

const Communication = (props) => {
  const { t, history, dispatch, match, hiddenMemoBox, title } = props;
  const [data, setData] = useState([]);
  const [modal, setModal] = useState(false);
  const [surveyMetricsModal, setSurveyMetricsModal] = useState(false);
  const [visualizationMetricsModal, setVisualizationMetricsModal] =
    useState(false);
  const [selectedDto, setSelectedDto] = useState({});
  const [memoTypeModal, setMemoTypeModal] = useState(false);
  const [memoBox, setMemoBox] = useState(COMMUNICATION_TYPE.POST);
  const [visualizationMetricsWrapper, setVisualizationMetricsWrapper] =
    useState({
      communicationResultsDetail: [],
      communicationResultsResp: undefined,
      communicationResultsAlun: undefined,
    });
  const [filterIsOpen, setFilterIsOpen] = useState(false);
  const [classes, setClasses] = useState([]);
  const [students, setStudents] = useState([]);
  const [employees, setEmployees] = useState([]);
  const context = useContext(SmartContext);
  const { postsFilter, setPostsFilter } = context;
  const [openCorrectionScreen, setOpenCorrectionScreen] = useState(false);

  const memoBoxes = [
    {
      icon: <EmailIcon />,
      title: t('communication.inbox-title-post'),
      type: COMMUNICATION_TYPE.POST,
    },
    {
      icon: <LiveHelp />,
      title: t('communication.inbox-title-survey'),
      type: COMMUNICATION_TYPE.SURVEY,
    },
    {
      icon: <ThumbsUpDownIcon />,
      title: t('communication.inbox-title-authorization'),
      type: COMMUNICATION_TYPE.AUTHORIZATION,
    },
    {
      icon: <HomeWork />,
      title: t('communication.inbox-title-activity'),
      type: COMMUNICATION_TYPE.ACTIVITY,
    },
    {
      icon: <ScheduleIcon />,
      title: t('communication.inbox-title-scheduled'),
      type: COMMUNICATION_TYPE.SCHEDULED,
    },
  ];

  function showLoading() {
    dispatch(changeLoadingTrue());
  }

  function hideLoading() {
    dispatch(changeLoadingFalse());
  }

  const onFilterToggle = () => {
    setFilterIsOpen(!filterIsOpen);
  };

  const toggleScreenCorrection = () => {
    setOpenCorrectionScreen(!openCorrectionScreen);
  };

  const getStatusByType = (item) => {
    if (item.examHeader && item.examHeader.id) {
      return t(`general.yesno.${!!item.examHeader.taskEnded}`);
    }
    if (item.taskHeader && item.taskHeader.id) {
      return t(`general.yesno.${!!item.taskHeader.taskEnded}`);
    }
    return null;
  };

  const loadCommunicationsByFilter = (filter) => {
    if (filterIsOpen) {
      onFilterToggle();
    }
    const query = communicationFindByTypeFilterQuery(filter);
    showLoading();
    GraphQl(query, {})
      .then((res) => {
        res.communicationListByFilter = res.communicationListByFilter.map(
          (item) => ({
            ...item,
            sentDescription: t(`general.yesno.${item.sent}`),
            scheduledDescription: t(`general.yesno.${item.scheduled}`),
            typeDescription: t(`communication.type-${item.type}`),
            createdAtDate: item.createdAtMili
              ? format(item.createdAtMili, 'dd/MM/yyyy')
              : '',
            scheduledToDate: item.scheduledTo
              ? ` ${format(item.scheduledTo, 'dd/MM/yyyy')} ${t(
                  'general.at'
                )} ${item.scheduledToHour}`
              : '',
            sentAtDateHour: item.sentAt
              ? ` ${format(item.sentAt, `dd/MM/yyyy HH:mm`)}`
              : '',
            dueDate: item.dueDateMili
              ? format(item.dueDateMili, 'dd/MM/yyyy')
              : '',
            formattedTaskEndedStatus: getStatusByType(item),
            auditStatus: t(`audit-status.${item.timelineIntegrationStatus}`),
          })
        );
        setData(res.communicationListByFilter);
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const onFilterClickHandler = (filter) => {
    if (filter) {
      setPostsFilter(filter);
      loadCommunicationsByFilter(filter);
    } else if (
      postsFilter &&
      postsFilter.communicationType.value !== COMMUNICATION_TYPE.OCCURRENCE &&
      postsFilter.communicationType.value !== COMMUNICATION_TYPE.EXAM
    ) {
      setMemoBox(postsFilter.communicationType.value);
      loadCommunicationsByFilter(postsFilter);
    } else {
      loadCommunicationsByFilter({
        id: 0,
        classes: [],
        students: [],
        employees: [],
        periodType: PERIOD_TYPE.DELIVERY,
        initialPeriod: new Date(),
        finalPeriod: new Date(),
        communicationType: { value: memoBox },
        onlySent: false,
      });
    }
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  const toggleVisualizationMetricsModal = () => {
    setVisualizationMetricsModal(!visualizationMetricsModal);
  };

  const toggleSurveyMetricsModal = () => {
    setSurveyMetricsModal(!surveyMetricsModal);
  };

  const onTypeSelectionHandler = (type) => {
    history.push(`/minime/postagem/mnt/${type}/0`);
  };

  const addItemClickHandler = () => {
    if (hiddenMemoBox) {
      if (memoBox === COMMUNICATION_TYPE.PLAN) {
        history.push(`/minime/plano-aula/mnt/0`);
      } else {
        onTypeSelectionHandler(memoBox);
      }
    } else {
      setMemoTypeModal(!memoTypeModal);
    }
  };

  const removeItemClickHandler = (evt, rowData) => {
    setSelectedDto({
      ...rowData,
    });
    toggleModal();
  };

  const editItemClickHandler = (evt, rowData) => {
    setSelectedDto({
      ...rowData,
    });
    if (rowData.type === COMMUNICATION_TYPE.PLAN) {
      history.push(`/minime/plano-aula/mnt/${rowData.id}`);
    } else {
      history.push(`/minime/postagem/mnt/${rowData.type}/${rowData.id}`);
    }
  };

  const deleteItem = () => {
    toggleModal();
    showLoading();
    const removeMutation = communicationRemoveQuery(selectedDto.id);
    GraphQl(removeMutation, {})
      .then(() => {
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-removed')
        );
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-remove')
        );
      })
      .finally(() => {
        hideLoading();
        onFilterClickHandler();
        updatePendency(dispatch);
      });
  };

  const onMailBox = (mailboxC, e, type) => {
    e.preventDefault();
    setMemoBox(type);
    onFilterClickHandler({
      id: 0,
      classes: [],
      students: [],
      employees: [],
      periodType:
        type === COMMUNICATION_TYPE.SCHEDULED
          ? PERIOD_TYPE.SCHEDULED
          : PERIOD_TYPE.DELIVERY,
      initialPeriod: new Date(),
      finalPeriod: new Date(),
      communicationType:
        type === COMMUNICATION_TYPE.SCHEDULED
          ? { value: EMPTY_STRING }
          : { value: type },
      onlySent: false,
    });
  };

  const toggleMemoTypeModal = () => {
    setMemoTypeModal(!memoTypeModal);
  };

  const loadVisualizationMetricsDetailed = (communicationId) => {
    showLoading();
    const query = getCommunicationResultsViewedWrapper(communicationId);
    GraphQl(query, {})
      .then((res) => {
        const resultsViewedWrapper = {
          ...res.getCommunicationResultsViewedWrapper,
          communicationResultsDetail:
            res.getCommunicationResultsViewedWrapper.communicationResultsDetail.map(
              (item) => ({
                ...item,
                previewDate: item.previewDate
                  ? format(item.previewDate, 'dd/MM/yyyy HH:mm')
                  : null,
                viewed: item.viewed
                  ? t('general.yesno.true')
                  : t('general.yesno.false'),
                answerDate: item.answerDate
                  ? format(item.answerDate, 'dd/MM/yyyy HH:mm')
                  : null,
                answer: item.answer
                  ? item.answer
                  : t('communication.surveyDetails.notAnswered'),
              })
            ),
        };
        setVisualizationMetricsWrapper(resultsViewedWrapper);
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  const loadAllClasses = () => {
    const query = classListActivesByFunc();
    GraphQl(query, {}).then((res) => {
      res.classListActivesByFunc = res.classListActivesByFunc.map((item) => ({
        ...item,
        label: item.name,
        value: item.id,
      }));
      setClasses(res.classListActivesByFunc);
    });
  };

  const loadAllStudents = () => {
    const filter = {
      id: 0,
      classes: [],
      responsibles: [],
      menus: [],
      onlyActive: true,
    };
    const query = studentListByFilter(filter);
    GraphQl(query, {}).then((res) => {
      res.studentListByFilter = res.studentListByFilter.map((item) => ({
        ...item,
        label: item.fullName,
        value: item.id,
      }));
      setStudents(res.studentListByFilter);
    });
  };

  const loadAllEmployees = () => {
    const query = employeeListByFilter();
    GraphQl(query, {}).then((res) => {
      res.employeeListByFilter = res.employeeListByFilter.map((item) => ({
        ...item,
        label: item.name,
        value: item.id,
      }));
      setEmployees(res.employeeListByFilter);
    });
  };

  const onVisualizationMetricsClickHandler = (evt, rowData) => {
    setSelectedDto({
      ...rowData,
    });
    loadVisualizationMetricsDetailed(rowData.id);
    toggleVisualizationMetricsModal();
  };

  const onSurveyMetricsClickHandler = (evt, rowData) => {
    setSelectedDto({
      ...rowData,
    });
    toggleSurveyMetricsModal();
  };

  const onActivityCorrectionClickHandler = (evt, rowData) => {
    setSelectedDto({
      ...rowData,
    });
    toggleScreenCorrection();
  };

  const filterBuildFunction = () => (
    <CommunicationFilter
      filterToggle={onFilterToggle}
      isFiltering={filterIsOpen}
      filterClick={onFilterClickHandler}
      classes={classes}
      students={students}
      employees={employees}
      lastFilter={postsFilter}
      memoBox={memoBox}
    />
  );

  const printRegistrationForm = async (e, rowData) => {
    const formData = new FormData();

    formData.append(REPORT_PARAMETERS.REPORTTYPE, REPORT_TYPES.RELA_COPEAU);
    formData.append(REPORT_PARAMETERS.pCO00MENS, rowData.id);

    showLoading();
    generateReport(formData)
      .then(async (res) => {
        openReport(res.data);
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('report.error-generate')
        );
      });
  };

  const actionsDisabledByConditional = (propss) => {
    if (propss.actions && propss.actions.length) {
      const copyProps = { ...propss };
      copyProps.actions.find(
        (a) => a.name === ACTION_NAME.VIEW_METRICS
      ).disabled = propss.data.type !== COMMUNICATION_TYPE.SURVEY;
      copyProps.actions.find(
        (a) => a.name === ACTION_NAME.VIEW_METRICS
      ).hidden = propss.data.type !== COMMUNICATION_TYPE.SURVEY;
      copyProps.actions.find((a) => a.name === ACTION_NAME.PRINT).hidden =
        propss.data.type !== COMMUNICATION_TYPE.SURVEY;
    }
  };

  const loadOccurrences = () => {
    setMemoBox(COMMUNICATION_TYPE.OCCURRENCE);
    onFilterClickHandler({
      id: 0,
      classes: [],
      students: [],
      employees: [],
      periodType: PERIOD_TYPE.DELIVERY,
      initialPeriod: new Date(),
      finalPeriod: new Date(),
      communicationType: { value: COMMUNICATION_TYPE.OCCURRENCE },
      onlySent: false,
    });
  };

  const loadExams = () => {
    setMemoBox(COMMUNICATION_TYPE.EXAM);
    onFilterClickHandler({
      id: 0,
      classes: [],
      students: [],
      employees: [],
      periodType: PERIOD_TYPE.DELIVERY,
      initialPeriod: new Date(),
      finalPeriod: new Date(),
      communicationType: { value: COMMUNICATION_TYPE.EXAM },
      onlySent: false,
    });
  };

  const loadPlans = () => {
    setMemoBox(COMMUNICATION_TYPE.PLAN);
    onFilterClickHandler({
      id: 0,
      classes: [],
      students: [],
      employees: [],
      periodType: PERIOD_TYPE.DELIVERY,
      initialPeriod: new Date(),
      finalPeriod: new Date(),
      communicationType: { value: COMMUNICATION_TYPE.PLAN },
      onlySent: false,
    });
  };

  const clearPostFilter = () => {
    if (
      match.params &&
      match.params.type &&
      match.params.type === COMMUNICATION_TYPE.OCCURRENCE
    ) {
      setPostsFilter({
        id: 0,
        classes: [],
        students: [],
        employees: [],
        periodType: PERIOD_TYPE.DELIVERY,
        initialPeriod: new Date(),
        finalPeriod: new Date(),
        communicationType: { value: COMMUNICATION_TYPE.POST },
        onlySent: false,
      });
    }
  };

  const loadByMatchParam = () => {
    if (
      match.params &&
      match.params.type &&
      match.params.type === COMMUNICATION_TYPE.OCCURRENCE
    ) {
      loadOccurrences();
    } else if (
      match.params &&
      match.params.type &&
      match.params.type === COMMUNICATION_TYPE.EXAM
    ) {
      loadExams();
    } else if (
      match.params &&
      match.params.type &&
      match.params.type === COMMUNICATION_TYPE.PLAN
    ) {
      loadPlans();
    } else {
      onFilterClickHandler();
    }
  };

  useEffect(() => {
    loadAllClasses();
    loadAllStudents();
    loadAllEmployees();
    loadByMatchParam();
    return async () => {
      await clearPostFilter();
    };
  }, []);

  return (
    <Fragment>
      {openCorrectionScreen && (
        <ActivityOrEvaluationCorrection
          isOpen={openCorrectionScreen}
          toggle={toggleScreenCorrection}
          dto={selectedDto}
          dispatch={dispatch}
          hideLoading={hideLoading}
          showLoading={showLoading}
          onFilterClickHandler={onFilterClickHandler}
        />
      )}
      <FullScreenDialog
        isOpen={visualizationMetricsModal}
        toggleDialog={toggleVisualizationMetricsModal}
        title={`${t(`communication.metrics-title.view.${selectedDto.type}`)} ${
          selectedDto.id
        }  ${selectedDto.title ? ` - ${selectedDto.title}` : ''}`}
      >
        <VisualizationMetricsView
          visualizationMetricsWrapper={visualizationMetricsWrapper}
          communicationType={selectedDto.type}
        />
      </FullScreenDialog>
      <FullScreenDialog
        isOpen={surveyMetricsModal}
        toggleDialog={toggleSurveyMetricsModal}
        title={`${t(
          `communication.metrics-title.result.${selectedDto.type}`
        )} ${selectedDto.id}  ${
          selectedDto.title ? ` - ${selectedDto.title}` : ''
        }`}
      >
        <SurveyMetricsView communicationId={selectedDto.id} />
      </FullScreenDialog>
      <Modal
        color="warning"
        title={t('notifications.attention')}
        btn="Warning"
        message={t('notifications.delete_modal')}
        toggle={toggleModal}
        modal={modal}
        onConfirm={deleteItem}
      />
      <MemoTypeModal
        isOpen={memoTypeModal}
        toggleFunction={toggleMemoTypeModal}
        onTypeSelectionHandler={onTypeSelectionHandler}
        history={history}
      />
      <Container>
        <Row className="Table">
          <Col md={12} lg={12}>
            <Card>
              <CardBody className="material-table-card">
                <div className="row">
                  {!hiddenMemoBox ? (
                    <Col md={2} lg={2}>
                      <div
                        className="card__title"
                        style={{
                          paddingTop: 25,
                          whiteSpace: 'nowrap',
                          zIndex: 100,
                        }}
                      >
                        <h5 className="bold-text">{t('panels.postagem')}</h5>
                      </div>

                      <div>
                        {memoBoxes.map((m, i) => (
                          <button
                            type="button"
                            className="inbox__list-button"
                            key={uuid()}
                            onClick={(e) => onMailBox(i, e, m.type)}
                          >
                            <MemoBox
                              title={m.title}
                              amount={m.amount}
                              selected={m.type === memoBox}
                            >
                              {m.icon}
                            </MemoBox>
                          </button>
                        ))}
                      </div>
                    </Col>
                  ) : null}
                  <Col
                    md={hiddenMemoBox ? 12 : 10}
                    lg={hiddenMemoBox ? 12 : 10}
                  >
                    <div className="material-table__wrap">
                      <MaterialTable
                        title={hiddenMemoBox && title}
                        data={data}
                        columns={columns(t, memoBox)}
                        pageSize={20}
                        showFilter
                        isFiltering={filterIsOpen}
                        filterToggle={onFilterToggle}
                        filterBuildFunction={filterBuildFunction}
                        deleteAction={toggleModal}
                        onRefreshClick={onFilterClickHandler}
                        onAddClick={addItemClickHandler}
                        onRemoveClick={removeItemClickHandler}
                        onEditClick={editItemClickHandler}
                        onViewVisualizationMetricsClick={
                          onVisualizationMetricsClickHandler
                        }
                        onViewMetricsClick={onSurveyMetricsClickHandler}
                        onActivityCorrectionClick={
                          onActivityCorrectionClickHandler
                        }
                        onPrintClick={printRegistrationForm}
                        memoType={memoBox}
                        actionsDisabled
                        actionsDisabledByConditional={
                          actionsDisabledByConditional
                        }
                      />
                    </div>
                  </Col>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

Communication.propTypes = {
  t: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  dispatch: PropTypes.func.isRequired,
  match: ReactRouterPropTypes.match,
  hiddenMemoBox: PropTypes.bool,
  title: PropTypes.string,
};

Communication.defaultProps = {
  match: {},
  hiddenMemoBox: false,
  title: '',
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(Communication)
);
